<script lang="ts">
  import { ConfigurationsWrapper } from '@shared/ui/configurations-wrapper';

  import { navigationLinksStore } from '@features/navigation';

  import ListLinks from './list-links.svelte';
  import { splitNavigationLinks } from '../libs/split-navigation-links';

  const legal = [
    {
      link: `terms-of-use`,
      title: 'Terms of Use',
    },
    {
      link: `privacy-policy`,
      title: 'Privacy Policy',
    },
  ];

  const socialLinks = [
    {
      link: 'https://www.instagram.com/u_f_d_a',
      title: 'Instagram',
      target: '_blank',
    },
  ];

  // $: socialLinks = $page.data.configurations.social_profiles as Configurations['social_profiles'];
  // $: preparedSocial = socialLinks
  //   ? socialLinks
  //       .filter((item) => item.type !== 'site')
  //       .map((item) => ({
  //         link: item.value,
  //         text: item.type,`
  //         target: '_blank',
  //       }))
  //   : [];

  $: links = splitNavigationLinks($navigationLinksStore);
</script>

<section class="grid grid-cols-2 gap-x-5 gap-y-10 md:flex md:w-full md:grid-cols-4 md:justify-between md:gap-6">
  <ListLinks links="{links.explore}" title="Explore" />
  <ListLinks links="{links.main}" title="Links" />
  <ListLinks links="{legal}" title="Legal" />
  <ConfigurationsWrapper>
    <ListLinks links="{socialLinks}" title="Follow us" slot="ufda" />
  </ConfigurationsWrapper>
</section>
